import * as util from "../helpers/util";

const nextTick = (cb: () => void) => {
  setTimeout(cb, 0);
};

/**
 * Convert a Promise to node style callback
 * @private
 */
export function nodeify<T>(promise: Promise<T>, callback: any): Promise<T> {
  if (!util.isFunction(callback)) {
    return promise;
  }

  promise.then(
    (resp) => {
      nextTick( () => { // not sure if this is needed, promises should be already executed on the event pool
        callback(null, resp);
      });
    },
    (err) => {
      nextTick(() => {
        callback(err, null);
      });
    });
}
